<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" [sublabel]="'OPACITY'" [information]="themeOptions.axes(axesXY, axesIndex).gridLines.color" [subinformation]="opacity + '%'">
  <div app-theme-option-content>
    <app-color-picker [itemColor]="color" [color]="gridLinesColor" (sendColor)="receiveValue($event)"></app-color-picker>
  </div>
  <div app-theme-option-subcontent>
    <app-slider [color]="color" [value]="opacity" (sendValue)="receiveOpacity($event)"></app-slider>
  </div>
</app-theme-option>